import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "BaseItemDialogModifiers column no-wrap overflow-hidden q-pb-20 full-height"
}
const _hoisted_2 = { class: "row items-center BaseItemDialogModifiers__table-header q-pa-sm q-mb-md" }
const _hoisted_3 = { class: "BaseItemDialogModifiers__header-cell BaseItemDialogModifiers__header-cell--name flex-1 fs-13px fw-500 text-cool-gray-100" }
const _hoisted_4 = { class: "BaseItemDialogModifiers__header-cell BaseItemDialogModifiers__header-cell--min flex-1 fs-13px fw-500 text-cool-gray-100" }
const _hoisted_5 = { class: "BaseItemDialogModifiers__header-cell BaseItemDialogModifiers__header-cell--max flex-1 fs-13px fw-500 text-cool-gray-100" }
const _hoisted_6 = { class: "BaseItemDialogModifiers__header-cell BaseItemDialogModifiers__header-cell--default flex-1 fs-13px fw-500 text-cool-gray-100" }
const _hoisted_7 = {
  key: 0,
  class: "column no-wrap flex-1 custom-scrollbar overflow-auto"
}
const _hoisted_8 = { class: "row items-center no-wrap flex-1 q-pl-sm q-pr-12 q-py-xs gap-12" }
const _hoisted_9 = { class: "fs-13px fw-600 text-cool-gray-100 flex-1" }
const _hoisted_10 = { class: "BaseItemDialogModifiers__accordion-header-cell BaseItemDialogModifiers__accordion-header-cell--min flex-1 fs-15px text-cool-gray-80" }
const _hoisted_11 = { class: "BaseItemDialogModifiers__accordion-header-cell BaseItemDialogModifiers__accordion-header-cell--max flex-1 fs-15px text-cool-gray-80" }
const _hoisted_12 = { class: "BaseItemDialogModifiers__accordion-header-cell BaseItemDialogModifiers__accordion-header-cell--default flex-1 fs-15px text-cool-gray-80" }
const _hoisted_13 = { class: "column no-wrap gap-12 q-mt-12" }
const _hoisted_14 = { class: "row items-center gap-12 flex-1" }
const _hoisted_15 = { class: "fs-13px fw-600 text-cool-gray-80 flex-1" }
const _hoisted_16 = {
  key: 0,
  class: "column no-wrap q-mt-12"
}
const _hoisted_17 = { class: "row items-center gap-12 no-wrap q-py-xs" }
const _hoisted_18 = { class: "row items-center gap-xs no-wrap flex-1" }
const _hoisted_19 = { class: "fs-13px text-cool-gray-80" }
const _hoisted_20 = {
  key: 0,
  class: "fs-13px text-cool-gray-80"
}
const _hoisted_21 = {
  key: 1,
  class: "bg-white rounded-12 shadow-1 q-pa-12"
}
const _hoisted_22 = {
  key: 0,
  class: "column no-wrap q-pl-sm"
}
const _hoisted_23 = { class: "row items-center gap-12 no-wrap q-py-xs" }
const _hoisted_24 = { class: "row items-center gap-xs no-wrap flex-1" }
const _hoisted_25 = { class: "fs-13px text-cool-gray-80" }
const _hoisted_26 = {
  key: 0,
  class: "fs-13px text-cool-gray-80"
}
const _hoisted_27 = {
  key: 1,
  class: "column flex-1 flex-center"
}
const _hoisted_28 = {
  key: 1,
  class: "flex flex-center full-height"
}

import { onMounted, reactive } from 'vue'
import { formatMonetaryAmount } from 'src/common/helpers/generator/monetaryAmount.helper'
import translate from 'src/common/helpers/language/translate'
import translationObject from '../../../../pages/Inventory/Item/ItemLibrary/translate/itemLibrary.translate'
import globalTranslateObject from 'src/translate/global.translate'
import useNotify from 'src/hook/useNotify'
import { catchError } from 'src/common/helpers/generator/error.helper'
import { IItemView, IModifierGroup, IModifierItem, ModifierGroupListResponse } from 'src/common/interfaces'
import { useAxios } from 'src/services/__vue_query__/api/fetchByApiClient'
import { Endpoints } from 'src/services/__vue_query__/endpoints'
import { handleAxiosResponse } from 'src/services/__vue_query__/api/helpers'

interface IProps {
  item: IItemView
  currency: string
}

interface ILocalModifierItem extends IModifierItem {
  modifier_items?: IModifierItem[]
}

interface ILocalModifierGroup extends IModifierGroup {
  expanded: boolean
  items: ILocalModifierItem[]
}

interface IState {
  modifiers: ILocalModifierGroup[]
  loading: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseItemDialogModifiers' },
  __name: 'BaseItemDialogModifiers',
  props: {
    item: {},
    currency: {}
  },
  setup(__props: any) {


const props = __props

const { t: globalT } = translate(globalTranslateObject)
const { t } = translate(translationObject)

const { notify } = useNotify()

const state = reactive<IState>({
  modifiers: [],
  loading: false,
})

async function transformData() {
  state.modifiers = []
  for (const modifierId of props.item?.modifiers) {
    const modifier = props.item?.modifier_data?.list?.find((modifierGroup) => modifierGroup.id === modifierId)
    if (modifier) {
      const modifierGroups = []
      const modifierItems = []
      for (const modifierItem of modifier.items as ILocalModifierItem[]) {
        if (modifierItem.entity_type === 2) {
          state.loading = true
          try {
            const filter = { id: modifierItem.entity_id }
            const request = useAxios<ModifierGroupListResponse>(Endpoints.INVENTORY_MODIFIER_PORTAL_LIST, { filter })
            await request.fetch()
            const { data } = handleAxiosResponse<ModifierGroupListResponse>(request)
            modifierItem.modifier_items = data.list[0].items
            modifierGroups.push(modifierItem)
          } catch (err) {
            const errors = catchError(err)
            for (const error of errors) notify(false, error)
          }
        } else modifierItems.push(modifierItem)
      }
      const stateModifier = {
        ...modifier,
        items: [...modifierGroups, { ...modifierItems[0], modifier_items: [...modifierItems] }],
        expanded: true,
      }
      state.modifiers.push(stateModifier)
    }
  }
  state.loading = false
}

onMounted(() => transformData())

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_k_divider = _resolveComponent("k-divider")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_EmptyListAlert = _resolveComponent("EmptyListAlert")!

  return (__props.item?.modifier_data?.list?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(globalT)('name_price')), 1 /* TEXT */),
          _createVNode(_component_q_separator, {
            vertical: "",
            size: "1px",
            color: "cool-gray-30",
            class: "q-mr-12"
          }),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(globalT)('min_qty')), 1 /* TEXT */),
          _createVNode(_component_q_separator, {
            vertical: "",
            size: "1px",
            color: "cool-gray-30",
            class: "q-mr-12"
          }),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(globalT)('max_qty')), 1 /* TEXT */),
          _createVNode(_component_q_separator, {
            vertical: "",
            size: "1px",
            color: "cool-gray-30",
            class: "q-mr-12"
          }),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(globalT)('default_qty')), 1 /* TEXT */)
        ]),
        (!state.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.modifiers, (modifier, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "column no-wrap"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["bg-off-white-10 q-pa-sm transition", [modifier.expanded ? 'rounded-20' : 'rounded-12']])
                  }, [
                    _createVNode(_component_q_expansion_item, {
                      modelValue: modifier.expanded,
                      "onUpdate:modelValue": ($event: any) => ((modifier.expanded) = $event),
                      "default-opened": "",
                      dense: "",
                      "dense-toggle": "",
                      "hide-expand-icon": "",
                      "header-class": "BaseItemDialogModifiers__accordion items-center rounded-12",
                      groups: "items"
                    }, {
                      header: _withCtx(({ expanded }) => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(modifier.name), 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(modifier.min_selection), 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(modifier.max_selection), 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(modifier.min_selection), 1 /* TEXT */),
                          _createVNode(_component_k_icon, {
                            class: _normalizeClass(["cursor-pointer transition", { 'rotate-180': expanded }]),
                            name: "arrow-down",
                            color: "cool-gray-70",
                            size: "24px"
                          }, null, 8 /* PROPS */, ["class"])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modifier.items, (modifierItem, itemIndex) => {
                            return (_openBlock(), _createElementBlock("div", { key: itemIndex }, [
                              (modifierItem.entity_type === 2)
                                ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                                    key: 0,
                                    "default-opened": "",
                                    dense: "",
                                    "dense-toggle": "",
                                    "hide-expand-icon": "",
                                    class: "bg-white rounded-12 shadow-1 q-pa-12",
                                    "header-class": "BaseItemDialogModifiers__accordion items-center rounded-12",
                                    groups: "items"
                                  }, {
                                    header: _withCtx(({ expanded }) => [
                                      _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("span", _hoisted_15, _toDisplayString(modifierItem.name), 1 /* TEXT */),
                                        _createVNode(_component_k_icon, {
                                          class: _normalizeClass(["cursor-pointer transition", { 'rotate-180': expanded }]),
                                          name: "arrow-down",
                                          color: "cool-gray-70",
                                          size: "24px"
                                        }, null, 8 /* PROPS */, ["class"])
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      (modifierItem.modifier_items)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modifierItem.modifier_items, (child, childIndex) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: childIndex,
                                                class: "column no-wrap"
                                              }, [
                                                _createElementVNode("div", _hoisted_17, [
                                                  _createElementVNode("div", _hoisted_18, [
                                                    _createElementVNode("span", _hoisted_19, _toDisplayString(child.name), 1 /* TEXT */),
                                                    (Number(child.price) > 0)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(formatMonetaryAmount)(Number(child.price), __props.currency)), 1 /* TEXT */))
                                                      : _createCommentVNode("v-if", true)
                                                  ]),
                                                  _createCommentVNode(" <span class=\"BaseItemDialogModifiers__item-cell BaseItemDialogModifiers__item-cell--min flex-1 fs-13px text-cool-gray-80\">\n                          {{ child.min_selection }}\n                        </span>\n                        <span class=\"BaseItemDialogModifiers__item-cell BaseItemDialogModifiers__item-cell--max flex-1 fs-13px text-cool-gray-80\">\n                          {{ child.max_selection }}\n                        </span>\n                        <span class=\"BaseItemDialogModifiers__item-cell BaseItemDialogModifiers__item-cell--default flex-1 fs-13px text-cool-gray-80\">\n                          {{ child.default_selection }}\n                        </span> ")
                                                ]),
                                                (childIndex < modifierItem.modifier_items.length - 1)
                                                  ? (_openBlock(), _createBlock(_component_k_divider, {
                                                      key: 0,
                                                      dotted: true,
                                                      color: "cool-gray-50",
                                                      class: "q-my-sm"
                                                    }))
                                                  : _createCommentVNode("v-if", true)
                                              ]))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ]))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */))
                                : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    (modifierItem.modifier_items)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modifierItem.modifier_items, (child, childIndex) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: childIndex,
                                              class: "column no-wrap"
                                            }, [
                                              _createElementVNode("div", _hoisted_23, [
                                                _createElementVNode("div", _hoisted_24, [
                                                  _createElementVNode("span", _hoisted_25, _toDisplayString(child.name), 1 /* TEXT */),
                                                  (Number(child.price) > 0)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(formatMonetaryAmount)(Number(child.price), __props.currency)), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                                ]),
                                                _createCommentVNode(" <span class=\"BaseItemDialogModifiers__item-cell BaseItemDialogModifiers__item-cell--min flex-1 fs-13px text-cool-gray-80\">\n                          {{ child.min_selection }}\n                        </span>\n                        <span class=\"BaseItemDialogModifiers__item-cell BaseItemDialogModifiers__item-cell--max flex-1 fs-13px text-cool-gray-80\">\n                          {{ child.max_selection }}\n                        </span>\n                        <span class=\"BaseItemDialogModifiers__item-cell BaseItemDialogModifiers__item-cell--default flex-1 fs-13px text-cool-gray-80\">\n                          {{ child.default_selection }}\n                        </span> ")
                                              ]),
                                              (childIndex < modifierItem.modifier_items.length - 1)
                                                ? (_openBlock(), _createBlock(_component_k_divider, {
                                                    key: 0,
                                                    dotted: true,
                                                    color: "cool-gray-50",
                                                    class: "q-my-sm"
                                                  }))
                                                : _createCommentVNode("v-if", true)
                                            ]))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue"])
                  ], 2 /* CLASS */),
                  (index < state.modifiers.length - 1)
                    ? (_openBlock(), _createBlock(_component_k_divider, {
                        key: 0,
                        size: "md",
                        class: "q-my-md"
                      }))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createVNode(_component_q_spinner, {
                size: "4em",
                color: "cool-gray-40"
              })
            ]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_28, [
        _createVNode(_component_EmptyListAlert, {
          title: _unref(t)('dialog.modifier_no_data'),
          illustration: "/images/illustration.png"
        }, null, 8 /* PROPS */, ["title"])
      ]))
}
}

})